import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type createPlatformDataType = {
  file: string;
  errorCallback: Function;
  successCallback: Function;
  resultKey?: string;
};

type createPlatformBodyType = {
  file_data: string;
};

export default ({
  file,
  errorCallback,
  successCallback,
  resultKey = 'createAvailableAdvancePlatform',
}: createPlatformDataType) => {
  const bodyObj: createPlatformBodyType = {
    file_data: file,
  };

  return requestAsync({
    url: endpoints.getCreateAvailableAdvancePlatformUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getCreateAvailableAdvancePlatformUrl(),
    body: bodyObj,
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
};
